module.exports = __webpack_public_path__ + "img/resume-editor.c10b6d86.svg";